export const logImpression = (category, type, id) => window.ampLogImpression(`${category}/${id}/${type}`, id)
